import { Button, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import IsLoggedIn from '../auth/IsLoggedIn';
import Logout from './Logout';
import EventSelector from '../event/EventSelector';
import ToggleDarkmode from './ToggleDarkmode';
import HasGroup from '../auth/HasGroup';

function TopNavbar() {
  const authState = useSelector((state) => state.auth);

  return (
    <Navbar bg='primary' variant='dark' expand='lg'>
      <div className='container'>
        <Navbar.Brand href='/'>GK Office</Navbar.Brand>
        <IsLoggedIn>
          <Navbar.Toggle aria-controls='navbar' />
          <Navbar.Collapse id='navbar'>
            <Nav className='me-auto'>
              <NavDropdown title='Warenbestand' id='basic-nav-dropdown'>
                <HasGroup role='inventory'>
                  <>
                    <NavDropdown.Item href='/goods-receipt/book'>
                      Wareneingang buchen
                    </NavDropdown.Item>
                    <NavDropdown.Item href='/stock/correction'>
                      Bestandskorrektur
                    </NavDropdown.Item>
                    <NavDropdown.Item href='/stock/transfer'>
                      Umlagerung
                    </NavDropdown.Item>
                    <NavDropdown.Item href='/stock/movements'>
                      Lagerbewegungen
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href='/inventory-count'>
                      Inventur zählen
                    </NavDropdown.Item>
                    <NavDropdown.Item href='/inventory-counts'>
                      Inventuren
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                  </>
                </HasGroup>
                <NavDropdown.Item href='/stock'>
                  Bestandsübersicht
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title='Lieferungen' id='basic-nav-dropdown'>
                <NavDropdown.Item href='/crew-delivery/create'>
                  Lieferung anlegen
                </NavDropdown.Item>
                <NavDropdown.Item href='/crew-delivery/return/create'>
                  Retoure anlegen
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href='/crew-delivery/last/50'>
                  Lieferungen auflisten
                </NavDropdown.Item>
                <NavDropdown.Item href='/crew-delivery/open'>
                  Offene Lieferungen
                </NavDropdown.Item>
              </NavDropdown>
              {authState?.currentEvent?.bar_deliveries && (
                <NavDropdown title='Bar' id='bar-nav-dropdown'>
                  <NavDropdown.Item href='/bar-delivery/create'>
                    Bar-Lieferung anlegen
                  </NavDropdown.Item>
                  <NavDropdown.Item href='/bar-delivery/return/create'>
                    Retoure anlegen (Ware)
                  </NavDropdown.Item>
                  <NavDropdown.Item href='/bar-delivery/empties/create'>
                    Leergut-Rücknahme anlegen
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href='/bar-delivery/list'>
                    Bar-Lieferungen auflisten
                  </NavDropdown.Item>
                  <NavDropdown.Item href='/bar-delivery/open'>
                    Offene Bar-Lieferungen
                  </NavDropdown.Item>
                </NavDropdown>
              )}
              <NavDropdown title='Lieferziele' id='basic-nav-dropdown'>
                <NavDropdown.Item href='/crew-locations'>
                  Lieferziele
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href='/report/deliveries'>
                  Übersicht alle Lieferungen
                </NavDropdown.Item>
                <NavDropdown.Item href='/contingent'>
                  Kontingente
                </NavDropdown.Item>
              </NavDropdown>
              <HasGroup role='admin'>
                <NavDropdown title='Admin' id='admin-nav-dropdown'>
                  <NavDropdown.Item href='/manage/location-import'>
                    Lieferziel-Import
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href='/report/bar-billing'>
                    Bar-Abrechnung
                  </NavDropdown.Item>
                  <NavDropdown.Item href='/report/bar-deposit'>
                    Pfandübersicht
                  </NavDropdown.Item>
                </NavDropdown>
              </HasGroup>
              {/*<Nav.Link*/}
              {/*  href={*/}
              {/*    typeof window !== 'undefined' && window.innerWidth < 768*/}
              {/*      ? '/m/todo'*/}
              {/*      : '/todo'*/}
              {/*  }*/}
              {/*>*/}
              {/*  <i className='fas fa-list-check me-1' />*/}
              {/*  Aufgaben*/}
              {/*</Nav.Link>*/}
              <Nav.Link href='/logbook'>
                <i className='fas fa-book me-1' />
                Logbuch
              </Nav.Link>
              {/*<HasGroup role='backstage'>*/}
              {/*  <Nav.Link href='/backstage-delivery'>*/}
              {/*    <i className='fas fa-box me-1' />*/}
              {/*    Backstage-Lieferung*/}
              {/*  </Nav.Link>*/}
              {/*</HasGroup>*/}
            </Nav>
            <Nav>
              <Navbar.Text>{authState?.username}</Navbar.Text>
              {authState?.currentEvent?.markt && (
                  <HasGroup role='markt'>
                    <Button className='ms-2' variant='light' href='/markt'>
                      <i className='fas fa-cash-register' />
                    </Button>
                  </HasGroup>

              )}
              <ToggleDarkmode />
              <EventSelector />
              {/*<InactivityTimer />*/}
              <Logout />
            </Nav>
          </Navbar.Collapse>
        </IsLoggedIn>
      </div>
    </Navbar>
  );
}

export default TopNavbar;
